export default __webpack_public_path__ + "static/media/logo.88eb5015.svg";